import ArrayUtils from '../../../../common/utils/array';
import gameConfig from '../../config/game';

import PlayData from '../playdata/main';
import UrlUtils from '../../../../common/utils/url';


export default class Manager{

    constructor(){
        GAME_REF.obj.manager = this;

        this.nowItems = [];   // 場に置いてあるアイテム(常に10個)
    }

    
    init(){
        this.query = UrlUtils.getQuery();

        this.eggs = GAME_REF.obj.eggs;
        this.getList = GAME_REF.obj.getList;
        this.bith = GAME_REF.obj.birth;
        this.ui = GAME_REF.obj.ui;
        this.telop = GAME_REF.obj.telop;
        this.data = new PlayData();

        this.addPoint = parseInt(this.query.point ? this.query.point : gameConfig.point);

        this._create();
    }


    _create(){

        // ランダムに初期のタマゴのデータ生成
        this.nowItems = Array.from({length: gameConfig.num}, () => gameConfig.items[Math.floor(Math.random() * gameConfig.items.length)]);

        if(!ArrayUtils.isSameElement(this.nowItems)){
            const rIndex = Math.floor(Math.random() * (this.nowItems.length-1));
            this.nowItems[this.nowItems.length-1] = {...this.nowItems[rIndex]};
        }

        this.eggs.render(this.nowItems);
        this.telop.gameStart();
        this.ui.render();
    }


    start(){
        this.telop.hide();
        this.eggs.start();

        GAME_REF.obj.sound.playOne('se_bgm');
        GAME_REF.obj.ui.time.start();
    }


    correct(frameNo, pos='left'){
        this.bith.render(frameNo, pos);
        this.data.addList(frameNo);
        this.data.addScore(this.addPoint);
    }


    next(){
        this.ui.time.resume();
        this.bith.hide();
        this.eggs.next();
        this.ui.score.update(this.data._score);
        this.getList.addItem(this.data._latest);
        this.eggs.isDraggable = true;
    }


    gameEnd(){
        this.telop.gameEnd();
        this.eggs.gameEnd();
    }


    timerstop(){
        this.ui.time.pause();
        this.eggs.isDraggable = false;
    }
}